function buttons() {

    setTimeout(function(){
        $('.sticky-footer-action').fadeIn(300);
    }, 1000);

    var uplayer = $('#uplayer');
    $('section#main').on('click', '.startgal', function(e) {
        e.preventDefault();
        if (!!$('.lightbox').length) {
            $('.lightbox:first').trigger('click');
        } else {
            var link = $('#single-artist').find('li:first a').attr('href');
            if (link) {
                window.open(link);
            }
        }
    });

    $('#header li:not(.blank, .loginh, .disabled, .ww-btn, .soldout, .scrollbtn, .menu-item-language-current)>a, #mnav li:not(.soldout) a, .alink, .snlinks li:not(.scrollbtn)>a, #header .logo a, #footer p a').on('click', function(e) {
        //e.preventDefault();
        var disabled = $(this).parent().hasClass('disabled');
        var soldout = $(this).parent().hasClass('soldout');
        if (disabled || soldout) {
            return false;
        }
        var target = $(this).attr('target');
        if (target == '_blank' || target == '_top') {
            return;
        }
        $('#header li.current-menu-item').removeClass('current-menu-item');
        $(this).parent().addClass('current-menu-item');
        if (!$(this).hasClass('scrollbtn')) {
            $('#header').addClass('animout');
            $('#background').addClass('opacity0f');
            $('#header, body.scrolled, #footer').removeClass('scrolled');
        }
        if (!!$('.light').length) {
            $('.fimg').fadeOut(300);
        }

        $('.sticky-footer-action').fadeOut(300);
    });

    $('#header li.scrollbtn>a').on('click', function(e){
        if ( $('body.sn').length ) {
            $('#oc').trigger('click');
            log('test');
        }
    });
    $('#header li.disabled>a').on('click', function(e){
        e.preventDefault();
    });
    $('section#main').on('click', '.playtrack', function(e) {
        e.preventDefault();
        var songurl = $(this).attr('href');
        songurl = songurl + '&autoplay=1';
        log(songurl);
        uplayer.stop(true, true).animate({
            'height': '60px',
            'width': '100%'
        });
        $('.player-toggle').show();
        uplayer.find('div').html(`<iframe width="100%" height="60" src="${songurl}" frameborder="0"></iframe>`);
    })
    uplayer.on('click', '.player-popout', function(e) {
        e.preventDefault();
        var songurl = $('#uplayer div').find('iframe').attr('src');
        songurl = songurl + '&autoplay=1';
        songurl = songurl.replace('&footer_widget=1', '');
        log(songurl, 'test');
        open_window(songurl, 600, 120);
    })
    uplayer.on('click', '.player-video', function(e) {
        e.preventDefault();
        $('.player-toggle').hide();
        uplayer.stop(true, true).animate({
            'height': '170px',
            'width': '400px'
        });
        uplayer.find('div').html('<div class="vid-wrap" style="padding-bottom:42.65% !important"><iframe width="100%" height="60" src="https://www.youtube.com/embed/YexBIuZ9pik?autoplay=1&controls=0&showinfo=0" frameborder="0"></iframe></div>');
    });
    $(document).on('click', '.player-toggle', function(e) {
        var el = $(this);
        if (!uplayer.hasClass('big')) {
            uplayer.stop(true, true).animate({
                'height': '120px'
            }, {
                duration: 200,
                easing: 'easeInOutExpo',
                complete: function() {
                    uplayer.find('iframe').attr('height', '120');
                }
            });
            uplayer.addClass('big');
            el.text('Shrink');
        } else {
            uplayer.stop(true, true).animate({
                'height': '60px'
            }, {
                duration: 200,
                easing: 'easeInOutExpo',
                complete: function() {
                    uplayer.find('iframe').attr('height', '60');
                }
            });
            uplayer.removeClass('big');
            el.text('Expand');
        }
    });

}
$.fn.anchorAnimate = function(settings) {
    return this.each(function() {
        var caller = this;
        $(caller).on('click', function(event) {
            event.preventDefault();
            $('#main li ul li.current-menu-item').removeClass('current-menu-item');
            $('#main li ul li.active').removeClass('active');
            $('.about-nav li.active').removeClass('active');
            $(caller).parent().addClass('active');
            var locationHref = window.location.href;
            var elementClick = $(caller).attr("href");
            //elementClick = 'https:' + elementClick;
            if (elementClick === '#' || elementClick === 'https:#' || elementClick === '') {
                return;
            }

            var offset = $(elementClick).offset();
            var destination = offset ? offset.top : 0;

            $("html:not(:animated),body:not(:animated)").animate({
                scrollTop: destination
            }, 1200, 'easeInOutExpo', function() {
                window.location.hash = elementClick;
            });
            return false;
        })
    })
}

function open_window(url, width, height) {
    ddLog("Using open_window in _buttons.js");
    var my_window;
    // screen.width means Desktop Width
    // screen.height means Desktop Height
    var center_left = (screen.width / 2) - (width / 2);
    var center_top = (screen.height / 2) - (height / 2);
    my_window = window.open(url, "Title", "scrollbars=1, width=" + width + ", height=" + height + ", left=" + center_left + ", top=" + center_top);
    my_window.trigger('focus');
}

function trackOutboundLink(url) {
    ddLog("Using trackOutboundLink in _buttons.js");
    if (typeof __gaTracker == 'function') {
        __gaTracker('send', 'event', 'outbound', 'click', url, {
            'hitCallback': function() {
                //document.location = url;
            }
        });
    }
    if (typeof ga == 'function') {
        ga('send', 'event', 'outbound', 'click', url, {
            'hitCallback': function() {
                //document.location = url;
            }
        });
    }
}
